import { AlertCircle, RefreshCw } from "react-feather"
import { Button } from "@/components/ui/button"

interface SectionErrorProps {
  title?: string
  message: string
  onRetry?: () => void
  isRetrying?: boolean
}

export function SectionError({
  title = "読み込みに失敗しました",
  message,
  onRetry,
  isRetrying,
}: SectionErrorProps) {
  return (
    <div className="p-10 flex flex-col items-center justify-center gap-3 text-center">
      <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center">
        <AlertCircle className="text-red-500" size={24} />
      </div>
      <div>
        <p className="text-base font-bold text-slate-900">{title}</p>
        <p className="mt-1 text-sm text-slate-600">{message}</p>
      </div>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} disabled={isRetrying}>
          <RefreshCw className="mr-2" size={16} />
          {isRetrying ? "再読み込み中..." : "再読み込み"}
        </Button>
      )}
    </div>
  )
}
